<div *ngIf="compact" class="container horizontal layout middle space-between">
    <div *ngFor="let option of locales"
         class="option" 
         [ngStyle]="{'color': theme.publicArea.header.fontColor,
                     'border-bottom-color': isSelected(localeDataService.locale, option.id) ? theme.publicArea.header.fontColor : null}"
         (click)="localeDataService.setLocale(option.id)">
        {{option.shortLabel}}
    </div>
</div>
<!-- 
COMPACT
-->
<div *ngIf="!compact">
    <div class="languageBox layout horizontal center middle" [matMenuTriggerFor]="settingsMenu">
        {{localeDataService.locale|languageShortLabel}}
    </div>
    <mat-menu #settingsMenu="matMenu">
        <ng-container>
            <button mat-menu-item *ngFor="let option of locales"
                    (click)="localeDataService.setLocale(option.id)"
                    [class.selected]="isSelected(localeDataService.locale, option.id)">
                <span>{{option.label}}</span>
            </button>
        </ng-container>
    </mat-menu>
</div>